import type { InvoiceDetails } from '../../types';

/**
 * Der Positionsaufbau im Editor — die Teile, die ohne React auskommen.
 *
 * Aus InvoiceEditor herausgezogen, damit sie pruefbar sind: der Editor hat
 * keine Komponententests, und genau hier entscheidet sich, ob das Oeffnen
 * eines Belegs einen Neuaufbau ausloest (und damit schreibt) oder nicht.
 */

/**
 * Mit welcher Wahl „ohne Datum mitnehmen" der Editor einen Beleg oeffnet.
 *
 * Die gespeicherte Wahl des letzten Aufbaus (details.includeUndated), damit
 * „Positionen neu aufbauen" und der automatische Neuaufbau nach einer
 * Datumsaenderung so weiterbauen, wie der Beleg entstanden ist. Vorher stand
 * der Haken beim Oeffnen immer auf „ohne": ein Entwurf, der mit den Mengen
 * ohne Datum angelegt war, verlor sie beim ersten Zeitraumwechsel still.
 *
 * Nur ein echtes `true` zaehlt. Ein Altentwurf ohne das Feld (oder mit etwas
 * anderem im jsonb) oeffnet wie bisher mit „ohne" — die bewusste
 * Voreinstellung: die Mengen einem Zeitraum zuzuschlagen ist eine Aussage,
 * die nur der Bearbeiter treffen kann.
 */
export const gespeicherteWahlOhneDatum = (
    details: Pick<InvoiceDetails, 'includeUndated'> | null | undefined,
): boolean => details?.includeUndated === true;

/**
 * Wofuer zuletzt gebaut wurde: Zeitraum und die Behandlung undatierter Mengen.
 *
 * Kumulativ zaehlt allein der Stichtag. "Leistung von" wird dort nicht mehr
 * eingegeben, sondern vom Aufbau selbst nachgezogen — stuende es im
 * Schluessel, loeste jeder Aufbau durch sein eigenes Ergebnis sofort den
 * naechsten aus.
 *
 * Die Wahl steht im Schluessel: wer den Haken umstellt, baut neu auf. Beim
 * Oeffnen eines Belegs muss der Bezugspunkt deshalb mit DERSELBEN Wahl gebildet
 * werden, mit der der Haken vorbelegt wird — sonst laege zwischen beiden ein
 * Unterschied, und schon das Oeffnen baute den Beleg um.
 */
export const neuaufbauSchluessel = (
    kumulativ: boolean,
    from: string | undefined,
    to: string | undefined,
    ohneDatum: boolean,
): string => (kumulativ ? `stichtag|${to ?? ''}|${ohneDatum}` : `${from ?? ''}|${to ?? ''}|${ohneDatum}`);
